import NumberUtils from "./NumberUtils";

export type ClientPriceValues = {
  costForClientPerUnit?: number;
  costForClient?: number;
  profit?: number;
};

export default class ClientPriceUtils {
  static fromUnitPrice(unitPrice: number | undefined, quantity: number | undefined, vendorCost: number | undefined): ClientPriceValues {
    const normalizedUnitPrice = NumberUtils.isNumber(unitPrice) ? NumberUtils.roundTo4Digits(unitPrice) : undefined;
    if (!NumberUtils.isNumber(normalizedUnitPrice) || !NumberUtils.isNumber(quantity)) {
      return {
        costForClientPerUnit: normalizedUnitPrice,
        costForClient: undefined,
        profit: undefined,
      };
    }

    const clientAmount = NumberUtils.roundTo2Digits(normalizedUnitPrice * quantity);
    return {
      costForClientPerUnit: normalizedUnitPrice,
      costForClient: clientAmount,
      profit: this.profitFromAmount(clientAmount, vendorCost),
    };
  }

  static fromProfit(
    profit: number | undefined,
    quantity: number | undefined,
    vendorCost: number | undefined,
    currentUnitPrice: number | undefined,
  ): ClientPriceValues {
    if (!NumberUtils.isNumber(vendorCost)) {
      return {
        costForClientPerUnit: currentUnitPrice,
        costForClient: undefined,
        profit: NumberUtils.isNumber(profit) ? NumberUtils.roundTo2Digits(profit) : undefined,
      };
    }

    const requestedProfit = NumberUtils.isNumber(profit) ? profit : 0;
    const tentativeAmount = NumberUtils.roundTo2Digits(vendorCost + requestedProfit);
    if (!NumberUtils.isNumber(quantity) || quantity === 0) {
      return {
        costForClientPerUnit: currentUnitPrice,
        costForClient: tentativeAmount,
        profit: this.profitFromAmount(tentativeAmount, vendorCost),
      };
    }

    const unitPrice = NumberUtils.roundTo4Digits(tentativeAmount / quantity);
    return this.fromUnitPrice(unitPrice, quantity, vendorCost);
  }

  static profitFromAmount(clientAmount: number | undefined, vendorCost: number | undefined): number | undefined {
    return NumberUtils.isNumber(clientAmount) && NumberUtils.isNumber(vendorCost)
      ? NumberUtils.roundTo2Digits(clientAmount - vendorCost)
      : undefined;
  }
}
